import React from 'react';
import { useNavigate } from 'react-router-dom';
import { appRoutes } from '../routes';

const sectionColors: Record<string, string> = {
  car: 'bg-blue-500',
  gym: 'bg-yellow-500',
  finance: 'bg-green-500',
  todo: 'bg-purple-500',
  health: 'bg-red-500',
};

const Dashboard: React.FC = () => {
  const navigate = useNavigate();

  // Generate sections from appRoutes, excluding settings
  const sections = appRoutes
    .filter(route => !['settings'].includes(route.id))
    .map(route => ({
      id: route.id,
      title: route.title,
      description: route.description || '',
      icon: route.icon,
      path: route.path,
      color: sectionColors[route.id] || 'bg-gray-400',
    }));

  return (
    <div className="min-h-screen bg-theme-secondary pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {sections.map((section) => {
              const IconComponent = section.icon;
              return (
                <div
                  key={section.id}
                  onClick={() => navigate(section.path)}
                  className="bg-theme-primary rounded-lg shadow-sm border border-theme-primary p-6 cursor-pointer hover:shadow-md transition-shadow duration-200"
                >
                  <div className={`w-12 h-12 rounded-lg ${section.color} flex items-center justify-center mb-4`}>
                    <IconComponent className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="text-lg font-semibold text-theme-primary mb-2">
                    {section.title}
                  </h3>
                  <p className="text-theme-secondary text-sm">
                    {section.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 